var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_166_1",
    "data-name": "Component 166 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 27,
    viewBox: "0 0 36 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-eye",
    transform: "translate(0 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5707",
    d: "M18,4.5a15.878,15.878,0,0,1,7.732,2.062,22.757,22.757,0,0,1,5.549,4.412,29.8,29.8,0,0,1,4.56,6.355,1.5,1.5,0,0,1,0,1.342,29.8,29.8,0,0,1-4.56,6.355,22.757,22.757,0,0,1-5.549,4.412A15.878,15.878,0,0,1,18,31.5a15.878,15.878,0,0,1-7.732-2.062,22.757,22.757,0,0,1-5.549-4.412,29.8,29.8,0,0,1-4.56-6.355,1.5,1.5,0,0,1,0-1.342,29.8,29.8,0,0,1,4.56-6.355,22.757,22.757,0,0,1,5.549-4.412A15.878,15.878,0,0,1,18,4.5ZM32.788,18A28.141,28.141,0,0,0,29.04,12.97a19.686,19.686,0,0,0-4.794-3.8A12.9,12.9,0,0,0,18,7.5C9.908,7.5,4.612,15.587,3.212,18A28.141,28.141,0,0,0,6.96,23.03a19.686,19.686,0,0,0,4.794,3.8A12.9,12.9,0,0,0,18,28.5C26.092,28.5,31.388,20.413,32.788,18Z",
    fill: "#4897d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5708",
    d: "M18,12a6,6,0,1,1-6,6A6.007,6.007,0,0,1,18,12Zm0,9a3,3,0,1,0-3-3A3,3,0,0,0,18,21Z",
    fill: "#4897d1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOn);
export default __webpack_public_path__ + "static/media/eye_on.19f96808bd92b8d6eb2519e938b56ef1.svg";
export { ForwardRef as ReactComponent };